import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
import BaseRenderer from './BaseRenderer';
import Icon from '../Icon/Icon';
import Button from '../Button/Button';

export default class ContentRenderer extends PureComponent {

  static displayName = 'ContentRenderer';

  static propTypes = {
    className: PropTypes.string,
    description: PropTypes.node, // eslint-disable-line
    error: PropTypes.string, // eslint-disable-line
    expanded: PropTypes.bool,
    folder: PropTypes.bool,
    footer: PropTypes.node, // eslint-disable-line
    imageUrl: PropTypes.string,
    item: PropTypes.object, // eslint-disable-line
    level: PropTypes.number, // eslint-disable-line
    linked: PropTypes.bool,
    linkedListIcon: PropTypes.string, // eslint-disable-line
    linkedListTitle: PropTypes.string, // eslint-disable-line
    locked: PropTypes.bool,
    onCreateMenuItems: PropTypes.func, // eslint-disable-line
    onCloseMenu: PropTypes.func, // eslint-disable-line
    onExpand: PropTypes.func,
    related: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]),
    tag: PropTypes.string, // eslint-disable-line
    tags: PropTypes.arrayOf(PropTypes.string), // eslint-disable-line
    title: PropTypes.node, // eslint-disable-line
    type: PropTypes.string,
    typeIcon: PropTypes.string,
    typeTitle: PropTypes.string,
    warning: PropTypes.string, // eslint-disable-line
  };

  render() {
    const { className, imageUrl, folder, linked, linkedListIcon, linkedListTitle, locked, related, type, typeIcon, onExpand, expanded, typeTitle, ...rest } = this.props; // eslint-disable-line
    const style = imageUrl && { backgroundImage: `url('${imageUrl}')` };
    const icons = [
      related && <Icon key="related" name="related" className="related" title={typeof related === 'string' ? related : undefined} />,
      linked && <Icon key="link" name="link"/>,
      linkedListIcon && <Icon key="linked-list" name={linkedListIcon} title={linkedListTitle}/>,
      locked && <Icon key="locked" name="lock"/>,
    ];

    const capitalize = str => str && str[0].toUpperCase() + str.slice(1);

    return (
      <BaseRenderer {...rest} className={cx('content-renderer', className, type, { folder })} icons={icons}>
        {folder && <Icon name="folder-tab" className="folder-tab"/>}
        <div className="image" style={style}/>
        {type && <Icon name={typeIcon || type} className={type} title={ typeTitle || capitalize(type) }/>}
        {!!onExpand && <Button className="expandButton" onClick={onExpand} iconName={expanded ? 'collapse' : 'dropdown'}/>}
      </BaseRenderer>
    );
  }

}
